import Cookies from 'js-cookie';
import toast from "react-hot-toast";
import { axiosInstance } from "../lib/axios";

export const postBanner = async (form, pageName) => {
    try {
        const {
            title, subTitle, image, description, buttonText
        } = form;

        const formData = new FormData();
        // Required Field
        formData.append("title", title);
        formData.append("subTitle", subTitle);
        formData.append("pageName", pageName);
        formData.append("buttonText", buttonText);
        formData.append("description", description);

        if (image) {
            if (typeof image === "string") {
                formData.append("image", image);
            }
            else {
                formData.append("pictures", image);
            }
        }

        const accessToken = Cookies.get("accessToken");

        const res = await axiosInstance.post(
            `/banner/register`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        toast.success("Successfully Registered!");
        return res.data?.data;

    } catch (err) {
        console.error(err);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};

export const getBannerData = async (pageName) => {
    try {
        const res = await axiosInstance.get(
            `/banner/${pageName}`
        );
        return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};